<template>
  <div class="custom-card table-wrapper">

    <div class="flex gap-8 justify-between">
      
    
        <div class="flex w-4/5">
          <el-dropdown>
            <button
             class="sort-button flex items-center justify-center rounded-md h-full mr-3"
             :class="{ 'shadow-sm': sortList }"
             style="width: 40px;height: 40px;background-color: #F7FAFD;"
             
           >
             <sort-icon />
           </button>
           <el-dropdown-menu slot="dropdown" placement="right-end">
             <el-dropdown-item disabled>SORT BY</el-dropdown-item>
             
             <el-dropdown-item>
               <button @click="sortOrder = 'ASC'" class="flex items-center">
                 <span class="ml-2" :class="{ 'text-yellow-400' : sortOrder == 'ASC' }">ASC</span>
               </button>
             </el-dropdown-item>
             <el-dropdown-item>
               <button @click="sortOrder = 'DESC'" class="flex items-center" :class="{ 'text-yellow-400' : sortOrder == 'DESC' }">
                 <span class="ml-2" >DESC</span>
               </button>
             </el-dropdown-item>
             
           </el-dropdown-menu>
          </el-dropdown>

          <div class="table__search-input-wrapper">
            <span class="pr-2 opacity-50">
              <search-icon />
            </span>
            <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>

          <div class="date-picker flex items-center justify-center">
            <el-date-picker
              type="date"
              placeholder="Start Date"
              style="margin: 0"
              class="mr-3"
              v-model="startDate"
            />
  
            <el-date-picker
              type="date"
              placeholder="End Date"
              style="margin: 0"
              v-model="endDate"
            />
          </div>
       
        </div>

        <div class="flex gap-1 justify-end w-1/5">
          
          <button class="shadow-table2 rounded-md p-2">
            <img src="@/assets/images/icons/print-icon.svg" @click="printWindow()" alt="print icon" />
          </button>
          <button class="shadow-table2 rounded-md p-2">
            <img src="@/assets/images/icons/delete-icon-black.svg" alt="delete icon" />
          </button>
          <button class="shadow-table2 rounded-md p-2" @click="refetchBookings">
            <img :class="{ loading: 'animate-spin' }" src="@/assets/images/icons/refresh-icon.svg" alt="refresh icon" />
          </button>
        </div>
    </div>

    <table v-loading="loading" class="custom-table responsive-table">
      <thead>
        <tr class="shadow-table2 rounded-md">
          <th>
            <base-checkbox v-model="shouldSelectAllTracking" />
          </th>
          <th>Shipping Ref.</th>
          <th>Fleet ID</th>
          <th>Shipper</th>
          <th>Consignee</th>
          <th>Date & Time</th>
          <th>Last Updated</th>
          <th>Status</th>
          <th class="relative width-xs" tabindex="-1" @blur="isTableFilter = false">
            <span class="cursor-pointer" @click="isTableFilter = !isTableFilter">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg></span>
            <div v-if="isTableFilter">
              <table-filter @update-table="updateTableData($event)" />
            </div>
          </th>
        </tr>
      </thead>
      <tbody v-if="!loading && trackings.length == 0">
        <tr class="shadow-table2 rounded-md">
          <td colspan="7">
            <div class="flex flex-col justify-center items-center gap-4">
              <empty-tracking-icon />
              <p>No Tracking to display!</p>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="!loading && trackings.length">
        <tr v-for="tracking in trackings" :key="tracking.id" class="shadow-table2 rounded-md">
          <td>
            <base-checkbox :value="tracking.id" v-model="selectedTrackings" />
          </td>
          <td>{{ tracking.shippingReference }}</td>
          <td>{{ tracking.fleet ? tracking.fleet.fleetReference : "N/A" }}</td>
          <td>{{ tracking.shipperlocation ? tracking.shipperlocation.contactName : "N/A" }}</td>
          <td>
            {{
                tracking.consigneelocation ? tracking.consigneelocation.contactName : "N/A"
            }}
          </td>
          <td>
            {{ new Date(tracking.createdAt).toLocaleDateString("en-gb") }}
          </td>
          <td>-</td>
          <td class="flex flex-col gap-2">
            <span :style="{ 'color' : getStatusMessage(tracking.deliveryStatus) ? getStatusMessage(tracking.deliveryStatus).config.color : 'black' }">
              {{
                getStatusMessage(tracking.deliveryStatus) ? getStatusMessage(tracking.deliveryStatus).config.title : ""
              }}
          </span>
            <span >{{ getStatusMessage(tracking.deliveryStatus) ? getStatusMessage(tracking.deliveryStatus).config.message : "" }}</span>
            <div class="flex flex-row-reverse">
              <div :style="{ 'background-color' : getStatusMessage(tracking.deliveryStatus) ? getStatusMessage(tracking.deliveryStatus).config.color : 'black', opacity : 0.14  }" class="w-100 h-2">
              </div>
              <div :style="{ 'background-color' : getStatusMessage(tracking.deliveryStatus) ? getStatusMessage(tracking.deliveryStatus).config.color : 'black'  }" class="h-2 w-75"></div>
            </div>
            
          </td>
          <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer">
            <el-dropdown>
              <button>
                <vertical-ellipsis />
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <button class="flex items-center" @click="updateStatus(tracking)">
                    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.9415 3.04297L10.5315 4.45897C11.4765 5.40447 12 6.66197 12 7.99997C12 10.758 9.758 13 7 13V12L5 14L7 16V15C10.8595 15 14 11.8595 14 7.99997C14 6.12697 13.2695 4.36697 11.9415 3.04297Z"
                        fill="#DDB113" />
                      <path
                        d="M9 2L7 0V1C3.1405 1 0 4.1405 0 8C0 9.873 0.7305 11.633 2.0585 12.957L3.4685 11.541C2.5235 10.5955 2 9.338 2 8C2 5.242 4.242 3 7 3V4L9 2Z"
                        fill="#DDB113" />
                    </svg>
                    <span class="ml-2">Update Status</span>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button class="flex items-center" @click="viewShippingTimeliine(tracking.id)">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M9.48558 3.51855H2.34961V4.67522H9.48558V3.51855Z" fill="#FFA600" />
                      <path
                        d="M12.982 12.2152C13.5352 11.2381 13.3748 9.99295 12.5702 9.18918C12.0942 8.71316 11.4612 8.45044 10.7858 8.45044C10.1103 8.45044 9.47648 8.71316 9.00046 9.18918C8.52444 9.6652 8.26172 10.2982 8.26172 10.9745C8.26172 11.6482 8.52444 12.282 9.00046 12.7598C9.47648 13.2341 10.1094 13.4968 10.784 13.4968C11.2236 13.4968 11.6494 13.3849 12.0274 13.1716L14.8558 16L15.8104 15.0445L12.982 12.2152ZM11.8479 12.0358C11.2826 12.6011 10.2907 12.6011 9.72533 12.0358C9.14006 11.4496 9.14006 10.4985 9.72533 9.91232C10.008 9.62965 10.386 9.47358 10.7875 9.47358C11.1889 9.47358 11.5652 9.62965 11.8488 9.91232C12.1323 10.195 12.2884 10.573 12.2884 10.9745C12.2884 11.3759 12.1314 11.7522 11.8479 12.0358Z"
                        fill="#FFA600" />
                      <path
                        d="M11.5593 14.1332H1.60971C1.4519 14.1332 1.32444 14.0049 1.32444 13.8488V1.42026C1.32444 1.26245 1.4519 1.13499 1.60971 1.13499H11.5593C11.7171 1.13499 11.8437 1.26245 11.8437 1.42026V7.76026C12.2556 7.85043 12.6397 8.02645 12.9796 8.2779V1.42026C12.9796 0.637295 12.3431 0 11.5593 0H1.60971C0.826748 0 0.189453 0.637295 0.189453 1.42026V13.8488C0.189453 14.6309 0.826748 15.2682 1.60971 15.2682H11.5593C12.1533 15.2682 12.4342 15.1277 12.6457 14.6092L12.1307 14.0942C11.9408 14.174 11.6408 14.1332 11.5593 14.1332Z"
                        fill="#FFA600" />
                      <path d="M9.48558 6.77869H2.34961V7.93536H9.48558V6.77869Z" fill="#FFA600" />
                    </svg>

                    <span class="ml-2">View Shipment Timeline</span>
                  </button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="mt-3">
      <pagination-control
        :total="totalBookings"
        :pageNumber="pageNumber"
        @pageSize="pageSize = $event"
        @pageNumber="pageNumber = $event"
      />
    </div>

    <delete-modal :showModal="isDeleteModal" :itemToDelete="itemToDelete" :deletingItem="deletingTracking"
      @close-modal="isDeleteModal = false" @delete-item="deleteTracking" />
    <update-status-modal :showmodal="showUpdateStatusModal" @refetchBooking="refetchBookings" :booking="currentShipment" @close-modal="showUpdateStatusModal = false" />
  </div>
</template>

<script>
import moment from "moment";
import PaginationControl from "@/components/UI/pagination";
import TableFilter from "./TableFilter";
import UpdateStatusModal from "./Modals/UpdateStatusModal.vue";
export default {
  components: {
    PaginationControl,
    TableFilter,
    UpdateStatusModal
  },
  data() {
    return {
      showUpdateStatusModal: false,
      selectedRowId: null,
      loading: false,
      isTableFilter: false,
      trackings: [],
      totalTrackings : 1,
      removedTableData: [],
      isDeleteModal: false,
      itemToDelete: "Tracking",
      selectedTrackingId: null,
      deletingTracking: false,
      queryString: "",
      selectedTrackings: [],
      shouldSelectAllTracking: false,
      pageNumber: 1,
      pageSize: 10,
      totalBookings: 1,
      sortList: false,
      startDate: null,
      endDate: null,
      sortOrder : 'DESC',
      sortColumn : "",
      currentShipment : {}
    };
  },
  mounted() {
   
    this.getBookings({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      status : "tracking",
    });
  },
  computed: {
    filteredTrackings() {
      return this.filterArray(this.trackings, this.queryString);
    },
    isBulkAction() {
      return this.selectedTrackings.length ? true : false;
    },
  },
  watch: {
    shouldSelectAllTracking(val) {
      if (val) {
        this.trackings.forEach((tracking) => {
          this.selectedTrackings.push(tracking.id);
        });
      } else {
        this.selectedTrackings = [];
      }
    },
    sortOrder(){
      this.getBookings({
          sortOrder : this.sortOrder,
          startDate: this.startDate != null ? moment(this.startDate).format("YYYY-MM-DD") : "",
          endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
          searchTerm : this.queryString,
          pageSize : this.pageSize,
          pageNumber: this.pageNumber,
          status : "tracking",
          sortColumn : this.sortColumn
        });
    },
    queryString(){
      this.getBookings({
          sortOrder : this.sortOrder,
          startDate: this.startDate != null ? moment(this.startDate).format("YYYY-MM-DD") : "",
          endDate: this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
          searchTerm : this.queryString,
          pageSize : this.pageSize,
          status : "tracking",
          sortColumn : this.sortColumn,
        });
    },

    startDate() {
      if (this.startDate && this.endDate) {
        this.getBookings({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          status : "tracking",
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getBookings({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
      }
    },

    endDate() {
      if (this.startDate && this.endDate) {
        this.getBookings({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          status : "tracking",
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getBookings({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
      }
    },

    pageSize() {
      this.getBookings({
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        status : "tracking",
        ...(this.startDate && {
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
        ...(this.endDate && {
          endDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
      });
    },

    pageNumber() {
      this.getBookings({
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        status : "tracking",
        ...(this.startDate && {
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
        ...(this.endDate && {
          endDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
      });
    },

  },
  methods: {
    printWindow: function () {
      window.print();
    },
    
    refetchBookings(){
      this.loading = true
      this.getBookings({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        status : "tracking"
      });
    },
    updateTableData(data) {
      let index = this.removedTableData.indexOf(data);
      if (index >= 0) {
        this.removedTableData.splice(index, 1);
      } else {
        this.removedTableData.push(data);
      }
      this.isTableFilter = false;
      this.scrollLeft();
    },
    scrollLeft() {
      let container = document.getElementById("table-wrapper");
      console.log(container.scrollLeft);
      container.scrollLeft += 10000;
  
    },
    getStatusMessage(status) {
      const statusArray = [
        { key : "accepted", config : { color: '#09B78A', title: "Accepted", message: "Package Accepted" } },
        { key : "dispatched", config : { color: '#09B78A', title: "Dispatched", message: "Package dispatched" } },
        { key : "in_transit", config : { color: '#FFA600', title: "In Transit", message: "Package is on the way" } },
        {
          key : "processing", config : { color: '#09B78A', title: "Processing", message: "Package is ready for collection" },
        },
        { key : "delayed", config : { color: '#FFA600', title: "Delayed", message: "Delivery is delayed" } },
        { key : "canceled", config : { color: '#D72638', title: "Canceled", message: "Package delivery is canceled" } },
        { key : "pending", config : { color: '#FFA600', title: "Pending", message: "Package delivery is pending" } },
        {
          key : "fleet_scheduled_for_maintenance", config : {
            color: '#D72638', title: "Maintenance",
            message: "Package delivery is scheduled for maintenance",
          },
        },
        {
          key : "dropped_off", config : {
            color: '#FFA600', title: "dropped_off",
            message: "Package delivery is dropped off",
          },
        },
        { key : "declined", config : { color: '#D72638', title: "Declined", message: "Package delivery is declined" } },
        { key : "picked_up", config : { color: '#FFA600', title: "Picked up", message: "Package delivery is picked_up" } },
        { key : "assigned", config : { color: '#FFA600', title: "Assigned", message: "Package delivery is assigned" } },
        {
          key : "un_assigned", config : { color: '#D72638', title: "Unassigned", message: "Package delivery is unassigned" },
        },
        { key : "loading", config : { color: '#FFA600', title: "Loading", message: "Package delivery is loading" } },
        {
          key : "on_delivery", config : {
            color: '#FFA600', title: "on_delivery",
            message: "Package delivery is on_delivery",
          },
        },
        { key : "draft", config : { color: '#FFA600', title: "Draft", message: "Package is still a draft" } },
        { key : "process_fulfillment", config : { color: '#09B78A', title: "Fulfilled", message: "Package has been successfully delivered" } },
        { key : "process_handoff", config : { color: '#09B78A', title: "Handed off", message: "Package has been successfully handed off" } },
        { key : "active", config : { color: '#FFA600', title: "Active", message: "Package is active" } },
        { key : "scheduled", config : { color: '#FFA600', title: "Scheduled", message: "Package is Scheduled" } },
        { key : "completed", config : { color: '#09B78A', title: "Completed", message: "Package is completed" } },
        { key : "delivered", config : { color: '#09B78A', title: "Delivered", message: "Package has been returned successfully" } },
        { key : "process_returned", config : { color: '#FFA600', title: "Process returned", message: "Package has been delivered" } },
        { key : "encountered_damage_undergoing_repairs", config : { color: '#D72638', title: "Undergoing Repair", message: "Package encountered damage" } },
        { key : "process_returned", config : { color: '#FFA600', title: "Process returned", message: "Package has been delivered" } },
        { key : "unloading_at_destination", config : { color: '#FFA600', title: "Unloading", message: "Package is being unloaded" } },
        { key : "undergoing_destination_sorting", config : { color: '#FFA600', title: "Undergoing Sorting", message: "Package is been sorted" } },
        
        
        
        
      ];

      return statusArray.find((item) => item.key == status);
    },
    async getBookings(data) {
      try {
        this.loading = true;

        if(this.queryString.length == 0){
            const { data: response } = await this.$_getBookings(data);
            let filteredtrackings = response.data.shippings.filter(item => item.deliveryStatus != 'draft');
            this.trackings = filteredtrackings
            this.totalTrackings = response.data.totalCount;
        }else{
          const { data: response } = await this.$_searchBookings(this.queryString);
          this.trackings = response.data.shippingSearchResults;
        }
        
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    async deleteTracking() {
      this.deletingTracking = true;
      try {
        await this.$_deleteVehicle(this.selectedTrackingId);
        this.generateToast("Vehicle successfully deleted!", "success");
        this.getBookings();
        this.deletingTracking = false;
        this.isDeleteModal = false;
      } catch (error) {
        this.handleError(error);
        this.deletingTracking = false;
      }
    },
    showDeleteModal(vehicleId) {
      this.selectedTrackingId = vehicleId;
      this.isDeleteModal = true;
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    viewShippingTimeliine(vehicleId) {
      localStorage.setItem("vehicleId", vehicleId);
      this.$router.push({ name: "TrackingShippmentTimeline", params : { id : vehicleId } });
    },
    updateStatus(shipment) {
      this.currentShipment = shipment
      this.showUpdateStatusModal = true;
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>

<style scoped>
.primary {
  background: #09b78a1a;
  color: #09b78a;
  padding: 0.5rem;
  border-radius: 2px;
}

.table-wrapper {
  margin: 3rem 0;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.table-header__col-two {
  display: flex;
}

.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}

.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}

.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}

.table__search-input:focus {
  outline: none;
}

.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}

.custom-table {
  margin: 2rem 0;
  width: 100%;
}

.custom-table th {
  color: #060e18;
  font-weight: 600;
}

.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}

.custom-table td {
  color: #343633;
}

.table__action-btn {
  position: relative;
  padding: 0;
}

.table__action-options {
  position: absolute;
  width: 8rem;
  padding: 0.5rem 0;
  right: 2rem;
  background: #ffffff;
  z-index: 999;
  border-radius: 3px;
  box-shadow: 0px 0px 12px #dee0e7;
}

.table__action-option {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}

.table__action-option:hover {
  background: #fce4da;
}

.table__action-btn span {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .table__search-input-wrapper {
    width: 100%;
  }

  .table__btn-wrapper {
    width: 100%;
  }

  .button {
    width: 100%;
    margin-bottom: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table-header__col-two {
    flex-direction: column-reverse;
  }
}
</style>
